const typeAmountString = {
  PRICE: "PRICE",
  PERCENT: "PERCENT",
};

const typeAmountStringPersian = {
  PRICE: "تومان",
  PERCENT: "درصد",
};

const typeAmountValue = {
  1: typeAmountString.PRICE,
  2: typeAmountString.PERCENT,
};

export default {
  typeAmountString,
  typeAmountValue,
  typeAmountStringPersian,
};
